// import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Data } from '@angular/router';
// import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
// import { Label } from 'ng2-charts';
import { DataService } from 'src/app/Common/data.service';

import { Chart as ChartJS, LinearScale, CategoryScale, BarElement, Title, Tooltip, Legend, BarController } from 'chart.js';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DataService]
})
export class DashboardComponent implements OnInit {
  BarArray = [];
  BarChartForm: UntypedFormGroup;
  viewdata: any;  // Variable to hold dynamic data
  Groupviewdata: any;
  Myviewdata: any;

  public barChartLabels = ['High', 'Medium', 'Low'];
  public barChartOptions: any = {
    responsive: true,
    scales: {
      y: { beginAtZero: true }
    }
  };

  // Initialize the chart type to 'bar' for now
  public barChartType: string = 'bar';  // Use 'bar' as chart type

  public barChartLegend: boolean = true;
  public barChartData: any[] = [{ data: [], label: '' }];
  public GroupbarChartData = [{ data: [], label: '' }];
  public MybarChartData = [{ data: [], label: '' }];

  constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    // Register necessary components for Chart.js
    ChartJS.register(
      BarController,
      LinearScale,
      CategoryScale,
      BarElement,
      Title,
      Tooltip,
      Legend
    );

    this.BarChartForm = this._fb.group({
      spmode: ['']
    });

    // Fetch data for the three charts
    this.getdata();
    this.GroupChartdata();
    this.MyChartdata();
  }

  // Fetch data for "Service Requests Assigned To Me"
  getdata(): void {
    this.BarChartForm.patchValue({ spmode: 3 });
    this._dataservice.PostData('Category/GetBarChart/', this.BarChartForm.value).subscribe(result => {
      console.log('result1', result);
      if (result && result[0]) {
        if (result[0].data.length > 0) {
          this.viewdata = result;
        }
      }
      this.barChartData = [{ data: this.viewdata, label: 'Service Requests Assigned To Me By Priority' }];
      this.createChart('myChart', this.barChartData);  // Create chart after data is fetched
    });
  }

  // Fetch data for "My Groups Service Requests"
  GroupChartdata(): void {
    this.BarChartForm.patchValue({ spmode: 2 });
    this._dataservice.PostData('Category/GetBarChart/', this.BarChartForm.value).subscribe(result => {
      console.log('result2', result);
      if (result && result[0]) {
        if (result[0].data.length > 0) {
          this.Groupviewdata = result;
        }
      }
      this.GroupbarChartData = [{ data: this.Groupviewdata, label: 'My Groups Service Requests By Priority' }];

      this.createChart('groupChart', this.GroupbarChartData);  // Create chart after data is fetched
    });
  }

  // Fetch data for "My Service Requests"
  MyChartdata(): void {
    this.BarChartForm.patchValue({ spmode: 4 });
    this._dataservice.PostData('Category/GetBarChart/', this.BarChartForm.value).subscribe((result: any) => {
      console.log('result3', result);
      if (result && result[0]) {
        if (result[0].data.length > 0) {
          this.Myviewdata = result[0].data;
        }
      }
      this.MybarChartData = [{ data: this.Myviewdata, label: 'My Service Requests By Priority' }];

      this.createChart('myServiceChart', this.MybarChartData);  // Create chart after data is fetched
    });
  }

  // Method to create the charts using ChartJS directly
  createChart(chartId: string, chartData: any[]): void {
    const data = {
      labels: this.barChartLabels,
      datasets: chartData
    };

    const options = {
      responsive: true,
      scales: {
        y: { beginAtZero: true }
      }
    };

    // Create the chart using ChartJS with the 'chartId' as canvas ID
    new ChartJS(chartId, {
      type: 'bar',  // Use 'bar' type
      data: data,
      options: options
    });
  }
}
//   // public barChartPlugins = [];
//   // public barChartOptions = { scaleShowVerticalLines: false, responsive: true };
//   //   public barChartLabels = []; 
//   //   public barChartType = 'bar'; 
//   //   public barChartLegend = true; 
//   //   public barChartData = [];
//   BarChartForm: UntypedFormGroup;

//   constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder) { }
//   public barChartOptions = { scaleShowVerticalLines: false, responsive: true };
//   // public barChartLabels = []; 
//   public barChartLabels = ['High', 'Medium', 'Low'];
//   public barChartType = 'bar';
//   public barChartLegend = true;
//   public barChartData = [{ data: [], label: '' }];
//   //group wise chart
//   public GroupbarChartLegend = true;
//   public GroupbarChartData = [{ data: [], label: '' }];
//   Groupbarchart = [];
//   Groupviewdata: any;
//   //end of group wise chart

//   //service request By Me
//   public MybarChartLegend = true;
//   public MybarChartData = [{ data: [], label: '' }];
//   Myviewdata: any;
//   //end
//   barChartDataLocal = [];
//   LabelLocal = [];

//   barchart = [];
//   viewdata: any;
//   ngOnInit() {
//     this.BarChartForm = this._fb.group({
//       spmode: ['']
//     });
//     this.getdata();
//     this.GroupChartdata();
//     this.MyChartdata();
//   }

//   getdata() {
//     this.BarChartForm.patchValue({
//       spmode: 3,
//     });
//     this._dataservice.PostData('Category/GetBarChart/', this.BarChartForm.value).subscribe(result => {
//       this.viewdata = result;
//       this.barChartData = this.viewdata;
//     });
//   }

//   GroupChartdata() {
//     this.BarChartForm.patchValue({
//       spmode: 2,
//     });
//     this._dataservice.PostData('Category/GetBarChart/', this.BarChartForm.value).subscribe(result => {
//       this.Groupviewdata = result;
//       this.GroupbarChartData = this.Groupviewdata;
//     });
//   }

//   MyChartdata() {
//     this.BarChartForm.patchValue({
//       spmode: 4,
//     });
//     this._dataservice.PostData('Category/GetBarChart/', this.BarChartForm.value).subscribe(result => {
//       this.Myviewdata = result;
//       this.MybarChartData = this.Myviewdata;
//     });
//   }

// }
